export interface ClipboardFileInput {
  filename: string;
  mimeType: string;
  blob: Blob;
}

export type CopyFileToClipboard = (input: ClipboardFileInput) => Promise<void>;

async function assetBlob(source: string, mimeType: string): Promise<Blob> {
  const response = await fetch(source);
  if (!response.ok) throw new Error(`Unable to read asset for copying (${response.status})`);
  const blob = await response.blob();
  return blob.type === mimeType ? blob : new Blob([blob], { type: mimeType });
}

export async function copyAssetFile(
  input: { source: string; filename: string; mimeType: string },
  copyFileToClipboard: CopyFileToClipboard
): Promise<void> {
  await copyFileToClipboard({ filename: input.filename, mimeType: input.mimeType, blob: await assetBlob(input.source, input.mimeType) });
}
